export enum LocaleCode {
  EN = 'en',
  SL = 'sl',
  DE = 'de',
  ES = 'es'
}

export interface Locale {
  code: LocaleCode
  domain?: string
  file: string
  iso: string
  name: string
}
